<!--
  @Description 进度填写弹窗
  @Date 2021-12-31
  @Author liushuo
-->
<template>
  <vxe-modal
    ref="modal"
    size="mini"
    v-model="formVisible"
    title="进度填写"
    width="400px"
    @show="showModal"
  >
    <div class="slider-dv">
      <el-slider v-model="num" :step="10" show-stops :marks="marks">
      </el-slider>
    </div>
    <el-button
      @click="handleCommit"
      style="float: right; margin-top: 10px"
      size="mini"
      type="primary"
      >确认</el-button
    >
  </vxe-modal>
</template>
<script>
export default {
  name: 'scheduleSet',
  data () {
    return {
      formVisible: false,
      num: 0,
      // 当前选中行的id
      rowID: -1,
      // 当前选中行的类型，会由父组件打开本弹窗的时候赋值上去 [前端研发、后端研发、业务测试、技术测试]
      type: '',
      // 进度标记点
      marks: {
        0: '0%',
        20: '20%',
        40: '40%',
        60: '60%',
        80: '80%',
        100: {
          style: {
            color: '#1989FA'
          },
          label: this.$createElement('strong', '100%')
        }
      }
    }
  },
  methods: {
    showModal () {
    },
    // 提交
    async handleCommit () {
      const { data: res } = await this.$http.put('/Common/YKProjectSchedule/updateSchedule', {
        id: this.rowID,
        type: this.type,
        value: this.num
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.$message.success(res.data)
      this.$parent.refresh()

      this.$nextTick(() => {
        this.formVisible = false
      })
    },
  },
}
</script>
<style lang='less' scoped>
.slider-dv {
  padding: 0 20px 20px;
}
// vxemodal部分，美化标题太大的问题
/deep/ .vxe-modal--header {
  // font-size: 12px !important;
  height: 26px !important;
  padding: 2px 10px 0 10px !important;
}

// vxemodal关闭按钮
/deep/ .vxe-modal--close-btn {
  position: absolute !important;
  right: 8px !important;
  top: 6px !important;
  z-index: 1 !important;
  cursor: pointer !important;
}

// vxemodal标题
/deep/ .vxe-modal--title {
  font-size: 12px !important;
}
</style>